export default ({ key, order }) =>
  (a, b) => {
    const aIndex = order.indexOf(a[key].toLowerCase());
    const bIndex = order.indexOf(b[key].toLowerCase());

    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  };
